<template>
  <div class="header">
    <div class="hd_main">
      <div class="left_main">
        <el-tooltip content="康荟" placement="top">
          <el-image
            style="width: 80px; height: 80px"
            :src="require('@/assets/logo.jpg')"
            :fit="contain"
          />
        </el-tooltip>
        <a class="txt" href="/">龙海<span style="color:rgb(204,204,204)">之康</span></a>
      </div>
      <div class="right_main">
        <router-link to="/" active-class="active" exact>首页</router-link>
        <router-link to="/brand" active-class="active" exact>品牌理念</router-link>
        <router-link to="/information" active-class="active">企业资讯</router-link>
        <router-link to="/contact" active-class="active">联系我们</router-link>
        <router-link to="/about" active-class="active">关于我们</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped lang="scss">
.header {
  background: #fff;
  width: 100%;
  height: 100px;
}
.hd_main {
  margin: 20px 150px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left_main {
  display: flex;
  align-items: center;
}
.txt {
  margin-left: 15px;
  font-size: 30px;
  font-family: "PingFang SC";
  color: #02b2b5;
  font-weight: bolder;
  text-decoration: none;
}
.right_main {
  font-size: 16px;
}
.right_main a {
  border-radius: 30px;
  padding: 8px 20px;
  margin: 0 10px;
  text-decoration: none;
}
.right_main a:hover {
  background: #02b2b5;
  color: #fff;
}
.active {
  background: #02b2b5;
  color: #fff;
}
</style>